import _classCallCheck from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var Cache = /*#__PURE__*/function () {
  function Cache() {
    _classCallCheck(this, Cache);

    this.cache = new Map();

    if (Cache.instance) {
      return Cache.instance;
    }

    Cache.instance = this;
  }

  _createClass(Cache, [{
    key: "set",
    value: function set(key, value) {
      var ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300000;
      var expires = new Date().getTime() + ttl;
      this.cache.set(key, {
        value: value,
        expires: expires
      });
      console.info("Setting cache key:".concat(key, "."));
    }
  }, {
    key: "get",
    value: function get(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cachedItem;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cachedItem = this.cache.get(key);

                if (cachedItem) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", null);

              case 3:
                if (!(cachedItem && (cachedItem === null || cachedItem === void 0 ? void 0 : cachedItem.expires) > new Date().getTime())) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", cachedItem.value);

              case 5:
                if (cachedItem) {
                  this.cache.delete(key);
                }

                return _context.abrupt("return", null);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "clear",
    value: function clear(key) {
      this.cache.delete(key);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.cache.clear();
    }
  }, {
    key: "keys",
    value: function keys() {
      return this.cache.keys();
    }
  }]);

  return Cache;
}();

var instance = new Cache();
export default instance;